import { QueryTypes } from './data';
import HttpActions from './HttpActions';

class BaseApi {
  baseUrl = '';

  queryTypes = QueryTypes;

  static lang = '';

  constructor(baseUrl = '', version = '') {
    this.baseUrl = baseUrl;
    this.actions = new HttpActions(baseUrl, version);
    this.queryTypes = QueryTypes;
  }

  static setLang(lang) {
    this.lang = lang;
  }

  sendQuery = async (type, url, requestData = {}, options = {}, converterSuccess = dt => dt) => {
    let response;

    try {
      switch (type) {
        case QueryTypes.POST:
          response = await this.actions.post(url, requestData, options);
          break;
        case QueryTypes.DELETE:
          response = await this.actions.delete(url, requestData, options);
          break;
        case QueryTypes.PUT:
          response = await this.actions.put(url, requestData, options);
          break;
        case QueryTypes.PATCH:
          response = await this.actions.patch(url, requestData, options);
          break;
        default:
          response = await this.actions.get(url, requestData, options);
          break;
      }

      const { data, status } = response;
      const success = status === 200 && data.status === 0;
      return {
        success,
        // eslint-disable-next-line max-len
        data: success && converterSuccess(data.result || data.data.result || data.data), // два последних - для stolen evolution
        errorMessage: data.error_message ?? '',
        codeStatus: data.status,
      };
    } catch (err) {
      return {
        success: false,
        data: undefined,
        errorMessage: err.message ?? 'Request processing error',
        codeStatus: 418,
      };
    }
  };

  sendQueryFeedback = async (type, url, requestData = {}, options = {}, converterSuccess = dt => dt) => {
    let response;
    switch (type) {
      case QueryTypes.POST_FEEDBACK:
        response = await this.actions.post(url, requestData, options);
        break;
      default:
        response = await this.actions.get(url);
        break;
    }

    const { data, status } = response;
    const success = status === 200;
    const resultResponse = {
      success,
      data: success && converterSuccess(data.success),
      codeStatus: status,
    };
    return resultResponse;
  };

  sendLineQuery = async (type, url, requestData = {}, options = {}, converterSuccess = dt => dt) => {
    let response;
    switch (type) {
      case QueryTypes.POST:
        response = await this.actions.post(url, requestData, options);
        break;
      case QueryTypes.DELETE:
        response = await this.actions.delete(url, requestData, options);
        break;
      case QueryTypes.PUT:
        response = await this.actions.put(url, requestData, options);
        break;
      case QueryTypes.PATCH:
        response = await this.actions.patch(url, requestData, options);
        break;
      default:
        response = await this.actions.get(url, requestData, options);
        break;
    }

    const { data, status } = response;
    const success = status === 200;
    const resultResponse = {
      success,
      data: success && converterSuccess(data),
      errorMessage: success ? null : data.message,
      codeStatus: data?.status ? data.status : 'defaultMessage',
    };
    return resultResponse;
  };

  mockQuery = async (mockData, converter, errorMessage = '') => {
    const resultResponse = !errorMessage
      ? {
          success: true,
          data: converter(mockData),
          errorMessage: '',
          codeStatus: 200,
        }
      : {
          success: false,
          data: undefined,
          errorMessage,
          codeStatus: 404,
        };
    return resultResponse;
  };
}

export default BaseApi;
